import {
    GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST,
    GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS,
    GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE,
} from '../actions/actionTypes';

const initState = {
    isFetching: false,
    notifications: [],
    totalResults: 0,
    totalPages: 0,
    currentPage: 0,
};

const sketchOrderNotificationsReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                totalResults: action.response.totalResults,
                totalPages: action.response.totalPages,
                currentPage: action.response.page,
                notifications: action.response.resourceList,
            });
        case GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE:
            return Object.assign({}, initState);
        default:
            return state;
    }
};

export default sketchOrderNotificationsReducer;
